import React from "react";

import { SideNavigationLink } from "../../../../../components/SideNavigation";

//page template
import InfoPageTemplate from "../../../../../pageTemplates/InfoPageTemplate";
import { GOALS_SIDE_NAVIGATION_LINKS } from "../../constants";

type OverviewProps = {
	containerRef: React.RefObject<HTMLDivElement>;
	navItems: Array<SideNavigationLink>;
};

// this is a wrapper to hold the tornado template info for the dashboard page
const Overview = ({ containerRef, navItems }: OverviewProps) => {
	const mainContent = <div ref={containerRef} />;

	return (
		<div>
			<InfoPageTemplate
				mainContent={mainContent}
				pageTitle="Company Goals"
				navigationLinks={navItems}
				activeNavigationLinkKey={GOALS_SIDE_NAVIGATION_LINKS[1].key}
			/>
		</div>
	);
};

export default Overview;
